module.exports = __webpack_public_path__ + "static/media/jericoacoara-ce.43c69720.jpg";